'use strict';
(function($){
    /*
     * Vetology.WidgetName widget
     *
     * @description This is the main Vetology WidgetName widget that needs a description right here
     *
     * @options					See description for each option
     *
     * @method	See description above each method
     */
    $.widget(
        'Vetology.SubNationalDivision',
        {
            "options": {
            },
            /*
             * Vetology.Vetology._init
             *
             * @description	Initializes the Vetology.WidgetName
             *
             * @return NULL
             *
             */
            "_init": function(){
                var o = this;
                o._loadEvents();
            },
            /*
             * Vetology.Vetology._doSomething
             *
             * @description	Placeholder for a method
             *
             * @return NULL
             *
             */
            "_doSomething": function(){

            },
            /*
             * Vetology.Vetology._loadEvents
             *
             * @description	Load events
             *
             * @return NULL
             *
             */
            "_loadEvents": function(){
                var o = this;

                $("body").on("change", ".country-selector", function(e){
                    o._getTerritoryLabelsForCountry(this);
                });
            },
            /*
             * Vetology.Vetology._getTerritoryLabelsForCountry
             *
             * @description	Search for the labels assigned to the selected country
             *
             */
            "_getTerritoryLabelsForCountry": function(el){
                $.ajax(
                    {
                        url		: '/clinics/labels-for-country/' + el.value,
                        method	: 'get',
                        success	: function(response){
                            $(el).closest(".box-body").find('label[for="City"]').text(response.city_label + " / Locality");
                            $(el).closest(".box-body").find('label[for="State"]').text(response.state_label + " / Country subdivision");
                            $(el).closest(".box-body").find('label[for="Zip"]').text(response.zip_label);
                        },
                        error: function (jqXHR) {
                          console.log(jqXHR.responseText);
                        },
                        dataType: 'JSON'
                    }
                );
            }
        }
    );
})(jQuery);